import React from "react";
import {Control} from "react-hook-form/dist/types";
import {Controller, FieldPath, Path} from "react-hook-form";
import ComboBox from "./ComboBox";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {TabellaGenerica} from "@commons/types";
import {RegisterOptions} from "react-hook-form/dist/types/validator";

interface Props<T extends FieldValues> {
    control: Control<T>,
    name: FieldPath<T>,
    defaultValue: any,
    label: string,
    data?: TabellaGenerica[]
    isLoading?: boolean
    rules?: Omit<RegisterOptions<T, Path<T>>, "disabled" | "valueAsNumber" | "valueAsDate" | "setValueAs"> | undefined,
    disabled?: boolean
    inlineLabel?: boolean
}

export function ComboBoxGenerica<T extends FieldValues>(props: Props<T>) {
    const {control, name, defaultValue, label, data, isLoading, rules, disabled, inlineLabel = false} = props
    return <Controller name={name}
                       control={control}
                       defaultValue={defaultValue}
                       rules={rules ? rules :{required: true}}
                       render={({field: {value, onChange}, fieldState}) => {
                           return (
                               <ComboBox<TabellaGenerica> label={label} inlineLabel={inlineLabel} value={{id: value}} disabled={disabled} onChange={(value) => {
                                   onChange(value?.id)
                               }} fieldState={fieldState}
                                                          data={data}
                                                          isLoading={isLoading}

                                                          isSameFn={(a, z) => (a && z) ? a.id === z.id : false}
                                                          keyValueFn={(v) => v.id!}
                                                          displayValueFn={(v) => data && v ? v.descrizione! : ''}
                               />
                           )
                       }}
    />
}

export default ComboBoxGenerica;